import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/discounts_initialState.ts
var DISCOUNT_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  organizationId: 0,
  createdByLocationId: 0,
  name: "",
  locationId: 0,
  discountId: 0,
  posName: "",
  checkName: "",
  requireReason: false,
  description: "",
  applyTo: "item" /* ITEM */,
  type: "fixed" /* FIXED */,
  value: 0,
  active: true,
  locationDiscountId: 0,
  locationDiscountVersionId: 0,
  locationIds: [],
  exclusive: false,
  taxes: "applyBeforeTaxes" /* APPLY_BEFORE */
});

export { DISCOUNT_INITIAL_STATE };
